import { useCallback, useEffect, useRef, useState } from "react";
import { FormControl, Stack, Switch, Tab, Tabs, TextField, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Select from 'react-select';
import FormPageHeader from "../utilities/FormPageHeader";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { checkBlankSpace, checkNumber, checkShortKey, checkSpecialChar, checkString, emailValidation, isUrlValid } from "../utilities/FormValidation";
import * as Flags from 'country-flag-icons/react/3x2'
import customStyles from "app/shared-components/SelectCustomStyle";

const PortForm = () => {
    const [portCode, setPortCode] = useState();
    const [country, setCountry] = useState();
    const [portName, setPortName] = useState();
    const [tabValue, setTabValue] = useState(0);
    const [countryOptions, setCountryOptions] = useState();
    const [validError, setValidError] = useState({});
    const [checksubmit, setCheckSubmit] = useState(false);
    const params = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [editData, setEditData] = useState();
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [hideDelete, setHideDelete] = useState(true)
    const [saveDisable, setSaveDisable] = useState(true)

    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ports}`;
    const handleSubmit = async () => {
        setCheckSubmit(true)
        let model = {
            displayName: portName,
            portCode: portCode,
            countryName: country
        };
        if (portName && portCode && country) {
            try {
                if (params.id) {
                    await OAuthService.updateData(url, params.id, model);
                    setSuccessMsg("Data Updated Successfully")
                    setSnackState(true);
                } else {
                    await OAuthService.addData(url + '/saveport', model);
                    setSuccessMsg("Data saved Successfully")
                    setSnackState(true);
                }
            } catch (error) {
                setError(error?.response?.data?.errorMessage || error?.response?.data || error.message);
                return;
            }
            setTimeout(() => { navigate('/ports');}, 800)
        }
    }

    /**
      * Tab Change
    */
    const handleTabChange = (event, value) => {
        setTabValue(value);
    }

    const editPort = async () => {
        try {
            const result = await OAuthService.getEditData(url, params.id);
            const port = result.data;
            setPortName(port?.displayName);
            setPortCode(port?.portCode);
            setCountry(port?.countryName);
            setEditData(port);
        } catch (error) {
            setError(error.message)
        }
    }

    useEffect(() => {
        if (params.id) {
            editPort();
            setHideDelete(false)
        }
    }, [])

    useEffect(() => {
        if (portName && portCode && country) {
            if(editData){
                if (portName !== editData.displayName || portCode !== editData.portCode || country !== editData.countryName) {
                    setSaveDisable(false);
                }else{
                    setSaveDisable(true);
                }
            }else{
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    },[portName ,portCode, country]);
    
    const handleDelete = async () => {
        try {
            if (params.id) {
                await OAuthService.deleteData(url, params.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
            }
        } catch (error) {
            console.log('error', error)
            setError(error.message)
            return;
        }
        setTimeout(() => { navigate('/ports')},800);
    }

    const handleCountryChange = (data) => {
        // const countries = value.map((row) => {
        //     return row.value
        // });
        setCountry(data.value);
    };

    useEffect(() => {
        const country = async () => {
            const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.country}?size=1000`;
            const countries = await OAuthService.getList(url);

            const result = countries?.data?._embedded.countries.map((value) => {
                const Flag = Flags[value.isoCode];
                return { label: value.name, value: value.name, code: value.isoCode, icon: value.isoCode && <Flag width={18} style={{ marginInline: "5px" }} /> }
            })
            setCountryOptions(result);
        }
        country()
    }, [])

    const handleCancel = () => {
        navigate('/ports')
    }

    return (
        <div className="w-full overflow-scroll">
            <FormPageHeader
                componentName="Port"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                currentPage={params.id ? "Update Port" : "Add Port"}
                parentBreadcrumbData={[{ pageName: 'Port List', pageLink: '/ports' }]}
                error={error}
                successMsg={successMsg}
                snackState={snackState}
                hideDelete={hideDelete}
                handleCancel={handleCancel}
                saveDisable={saveDisable}
            >
                <Tabs
                    value={tabValue}
                    textColor="inherit"
                    onChange={handleTabChange}
                    indicatorColor="secondary"
                    sx={{ color: "yellow" }}
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full border-b-1' }}
                >
                    <Tab label="General" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24 max-w-3xl">
                <FormControl
                    // ref={formRef}
                    className="flex flex-col justify-center"
                >
                    <div className={tabValue !== 0 ? 'hidden' : ''}>
                        <Stack>
                            <label>*Port Code</label>
                            <TextField
                                className="mb-16"
                                type="text"
                                error={(checksubmit && !portCode) || validError?.portCode ? true : false}
                                name="portCode"
                                value={portCode}
                                required
                                disabled={params.id && true}
                                onChange={(e) => { setPortCode(e.target.value) && setValidError({ ...validError, portName: checkSpecialChar(e.target.value) || checkBlankSpace(e.target.value) }) }}
                                variant="outlined"
                                helperText={(checksubmit && !portCode) ? "This field is required" : validError.portCode}
                                InputLabelProps={{
                                    shrink: portCode ? true : false,
                                }}
                            />
                        </Stack>
                        <Stack>
                            <label>*Port Name</label>
                            <TextField
                                className="mb-16"
                                type="text"
                                name="portName"
                                error={(checksubmit && !portName) || validError?.portName ? true : false}
                                value={portName}
                                required
                                onChange={(e) => { setPortName(e.target.value.toUpperCase()) && setValidError({ ...validError, portName: checkString(e.target.value) }) }}
                                variant="outlined"
                                helperText={(checksubmit && !portName) ? "This field is required" : validError.portName}
                                InputLabelProps={{
                                    shrink: portName ? true : false,
                                }}
                            />
                        </Stack>
                        <Stack>
                            <label>*Select Country</label>
                            <Select name="country"
                                value={(countryOptions && country) && countryOptions.filter(obj => country.includes(obj.value))}
                                onChange={handleCountryChange}
                                className="basic-multi-select mb-56"
                                classNamePrefix="select"
                                options={countryOptions}
                                styles={customStyles()}
                                getOptionLabel={e => (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {e.icon}
                                        <span style={{ marginLeft: 5 }}>{e.label}</span>
                                    </div>
                                )}
                            />
                            <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !country) ? "This field is required" : validError.country}</Typography>
                        </Stack>
                    </div>
                </FormControl>
            </div>
        </div>
    )
};

export default PortForm;
